export default "__VITE_ASSET__b69de89e__"